import { render, staticRenderFns } from "./TIPO_NOME_FILIAL_RODAPE.vue?vue&type=template&id=5337a1b8"
import script from "./TIPO_NOME_FILIAL_RODAPE.vue?vue&type=script&lang=js"
export * from "./TIPO_NOME_FILIAL_RODAPE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports